import {Component, HostBinding, inject} from '@angular/core';
import {StoreService} from 'compob2b-libs'
import {NbIconModule} from '@nebular/theme'
import {NgIf} from '@angular/common'

@Component({
  selector: 'app-app-tree-toggle',
  imports: [
    NbIconModule,
    NgIf
  ],
  templateUrl: './app-tree-toggle.component.html',
  styles: `
    .catalog-show__icon {
      /*z-index: 99;*/
      /*position: absolute !important;*/
      width: 25px !important;
      cursor: pointer;
      color: var(--actions-icon-color);
      transform: rotate(180deg);
    }
  `
})
export class AppTreeToggleComponent {

  storeService = inject(StoreService);

  @HostBinding('class')
  get cssClass(): string[] {
    return this.storeService.getTreeOpen() ? ['open'] : ['close'];
  }
}
